export function SAVE_FILTERS_PLANS (state, data) {
    state.plans = data; 
}